import { ReactElement } from 'react';

import GuideList from '@/components/app/program/GuideList';
import Narrator from '@/components/app/program/Narrator';
import UpsellBanner from '@/components/UpsellBanner';

import { Description, Title, Wrapper } from './styles';
import { ProgramLayoutProps } from './types';

const ProgramLayout = ({ program }: ProgramLayoutProps): ReactElement => {
	return (
		<Wrapper data-testid="program-layout">
			<UpsellBanner />
			{program?.title && <Title>{program.title}</Title>}
			{program?.description && <Description>{program.description}</Description>}
			<Narrator program={program} />
			{program?.guides && <GuideList program={program} />}
		</Wrapper>
	);
};

export default ProgramLayout;
